import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@/constant/styles/common.less';

ReactDOM.render(<App />, document.getElementById('app'));
